import script from "./PPO.vue?vue&type=script&lang=js"
export * from "./PPO.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__